import React from "react";
import { fileUrl } from "@/lib/api";

const SIZES = { sm: "h-6 w-6 text-[9px]", md: "h-8 w-8 text-[11px]", lg: "h-16 w-16 text-lg" };

export const Avatar = ({ name = "", fileId, size = "sm", testid }) => {
  const cls = `${SIZES[size] || SIZES.sm} rounded-full shrink-0 object-cover border border-[#E3DED4]`;
  if (fileId)
    return <img src={fileUrl(fileId)} alt={name} data-testid={testid} className={cls} />;
  return (
    <span data-testid={testid}
      className={`${cls} bg-[#F1EDE6] text-[#6F6A60] font-semibold inline-flex items-center justify-center`}>
      {(name || "?").trim().charAt(0).toUpperCase()}
    </span>
  );
};

export default Avatar;
